import { DateUtil } from "@dto/util/DateUtil";
import { DatePicker, GetRef } from "antd";
import type { RangePickerProps } from 'antd/es/date-picker';
import dayjs from "dayjs";
import { forwardRef } from "react";

type ValueDate = NonNullable<RangePickerProps['presets']>[number];

const { RangePicker } = DatePicker;

export const RANGE_PICKER_PRESETS = {
  lastHour: { label: 'Last Hour', value: () => [dayjs().subtract(1, 'hour'), dayjs()] },
  last24h: { label: 'Last 24h', value: () => [dayjs().subtract(1, 'day'), dayjs()] },
  lastDay: {
    label: 'Last Day', value: () => [
      dayjs().subtract(1, 'day').startOf('day'),
      dayjs().subtract(1, 'day').endOf('day'),
    ]
  },
  lastWeek: {
    label: 'Last Week', value: () => [
      dayjs().subtract(1, 'week').startOf('day'),
      dayjs().endOf('day'),
    ]
  },
  lastMonth: {
    label: 'Last Month', value: () => [
      dayjs().subtract(1, 'month').startOf('day'),
      dayjs().endOf('day'),
    ]
  },
  last3Months: {
    label: 'Last 3 Months', value: () => [
      dayjs().subtract(3, 'months').startOf('day'),
      dayjs().endOf('day'),
    ]
  },
  last6Months: {
    label: 'Last 6 Months', value: () => [
      dayjs().subtract(6, 'months').startOf('day'),
      dayjs().endOf('day'),
    ]
  },
  lastYear: {
    label: 'Last Year', value: () => [
      dayjs().subtract(1, 'year').startOf('day'),
      dayjs().endOf('day'),
    ]
  },
} as const satisfies Record<string, ValueDate>;

export const RANGE_DATE_PICKER_DEFAULT_PRESETS: NonNullable<RangePickerProps['presets']> = [
  RANGE_PICKER_PRESETS.lastHour,
  RANGE_PICKER_PRESETS.last24h,
  RANGE_PICKER_PRESETS.lastWeek,
  RANGE_PICKER_PRESETS.lastYear,
];

export const RANGE_DATE_PICKER_EXPORT_REPORT_PRESETS: NonNullable<RangePickerProps['presets']> = [
  RANGE_PICKER_PRESETS.lastHour,
  RANGE_PICKER_PRESETS.lastDay,
  RANGE_PICKER_PRESETS.lastWeek,
  RANGE_PICKER_PRESETS.lastYear,
];

export type XmRangeDatePickerRef = GetRef<typeof RangePicker>;

const XmRangeDatePicker = forwardRef<XmRangeDatePickerRef, RangePickerProps>((props, ref) => {
  return (
    <RangePicker
      ref={ref}
      presets={RANGE_DATE_PICKER_DEFAULT_PRESETS}
      format={DateUtil.DATETIME_FORMAT}
      {...props}
    />
  );
});

export default XmRangeDatePicker;